module.exports = __webpack_public_path__ + "img/no_room.89e306ce.png";